import utils, { doesValueExist } from 'utils';

export const getIntegerValue = (value: any) => {
  if (typeof value === 'string') return utils.getIntegerFromDottedNumber(value);
  if (typeof value === 'number') return value;
  else return 0;
};

export const getPricePerField = (price: number | string) => {
  const value = getIntegerValue(price);
  const absPrice = Math.abs(value);

  const stringPrice = utils.getDotedNumber(absPrice);

  return value >= 0 ? stringPrice : `(${stringPrice})`;
};

export const checkIfNotNegative = (value: string | number) =>
  doesValueExist(value) && getIntegerValue(value) >= 0;
